import { render } from "./SuperAdminDatatableTDUserBlocked.vue?vue&type=template&id=4d413e7c"
import script from "./SuperAdminDatatableTDUserBlocked.vue?vue&type=script&lang=js"
export * from "./SuperAdminDatatableTDUserBlocked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__